import getActivePage from './get-active-page';
import getItemClickAction from './get-item-click-action';

export default {
  getActivePage,
  getItemClickAction,
};
